import './index.scss';

import React from 'react';
import { Redirect } from 'react-router-dom';
import Config from '../../config';

export default class extends React.Component {

  state = {
    back: false
  };

  openGoogle() {
    Config.setGroup(this.props.match.params.group);
    window.open(Config.getGoogleReviewLink(), '_blank');
  }

  render() {
    return (
      <div className="content-inner-container google">
        <div className="google-inner">
          <div className="back" onClick={() => this.setState({ back: true })}>
            <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
          </div>
          <i className="fa fa-google" />
          <p>
            Google lets us stay connected with our customers, fans and friends - and lets you review businesses.
          </p>
          <button onClick={this.openGoogle.bind(this)} className="mobile">
            Click to review us on Google
          </button>
          <img className="desktop" src="/images/google stars.png" />
          <p className="explainer">
            Click on the <strong>"Write a review"</strong> button<br />
            <strong>Sign in</strong> with your Google account <br />
            Then simply select a stay rating then write a description of your experience of the business.
          </p>
          <button onClick={this.openGoogle.bind(this)} className="desktop">
            Click to review us on Google
          </button>
          <p className="explainer note">
            Note: This website is not affiliated with or endorsed by Google.
          </p>
        </div>
        {
          this.state.back ? (
            <Redirect to={`/${this.props.match.params.group}/${this.props.match.params.key}/thank-you`} />
          ) : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/states/google/index.js